import { render, staticRenderFns } from "./Newstock.vue?vue&type=template&id=643e19f0&"
import script from "./Newstock.vue?vue&type=script&lang=ts&"
export * from "./Newstock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports